import React, { PureComponent, useState } from 'react';

import { Modal, ButtonToolbar } from 'reactstrap';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ThemeProps, RTLProps, UserProps } from '../../prop-types/ReducerProps';
import moment from 'moment';
import Alert from '../Alert';
import { Link } from 'react-router-dom';
import AlertIcon from 'mdi-react/EyeIcon';
import Button from '@material-ui/core/Button';
import ActiveIcon from 'mdi-react/CheckDecagramIcon';
import classNames from 'classnames';

import { bindActionCreators } from 'redux';
import {isMobile} from 'react-device-detect';
import buyersListActions from '../../../redux/actions/buyersListActions';
import TrialSubscribe from './TrialSubscribe';

import { 
	setLocalStorage,
	getLocalStorage,
	deleteLocalStorage
} from "../../../shared/helpers/utils";


class ProjectViewsAlert extends PureComponent {
	
  
  static propTypes = {
    theme: ThemeProps.isRequired,
    rtl: RTLProps.isRequired,
    children: PropTypes.element.isRequired,
    location: PropTypes.shape({}).isRequired,
    user: UserProps.isRequired,
  };
  
  constructor(props) {
    super(props)
    this.state = {
	    subscribe:false,
	    modal:false
    } 
    this.setSubscribe = this.setSubscribe.bind(this);
    this.toggle = this.toggle.bind(this);
   }
   
   componentDidMount() {	  
	 const seen = getLocalStorage('trial_', 'trialLimit');
	 
	 if(localStorage && !seen){
		 this.setState({ modal : true});
		 setLocalStorage('trial_', 'trialLimit', true);
	 }
	
   }
   
   setSubscribe(sub){
	   this.setState( {subscribe:sub} );
   }
      
   toggle(){
	   const { modal } = this.state;
		if(modal){
			this.setState({ modal : false})
		}else{
			this.setState({ modal : true})
		}
   }
  

  render() {
    const {
      theme, children, rtl, location, user, planViews
    } = this.props;
	
	if(planViews.allowed == "Unlimited") return null;
    const modalClass = classNames({
	      'modal-dialog--colored': false,
	      'modal-dialog--header': true,
	   });
    const { subscribe, modal } = this.state;
    const viewedCount = planViews.viewed
    const maxViews = user && user.pipelineProjectViews && user.pipelineProjectViews > 0 ? user.pipelineProjectViews : planViews.allowed;
    const remainingViews = !isNaN(planViews.allowed) ? maxViews - viewedCount : "Unlimited";   
    const dayOfMonth = user.pipelineViewResetDayOfMonth ? user.pipelineViewResetDayOfMonth : 1;
	var date = new Date(), d = date.getDate(), y = date.getFullYear(), m = date.getMonth();
	if(dayOfMonth > d){
		m--;
	}
	const lastDay = Math.floor(new Date(y, m, dayOfMonth-1).getTime() / 1000);
	const restDate = moment.unix(lastDay).add(1, 'month').format('MM/DD/YYYY');
	    return (
	      <Alert color="success" className="alert--bordered" alertId="trialAccount" icon iconItem={<AlertIcon />} minimizeText={`${remainingViews > 0 ? remainingViews : 0} of ${maxViews} project views remaining`}>
	     
	          <p>
	          	
	          	<div><strong>{remainingViews > 0 ? remainingViews : 0}</strong> of <strong>{maxViews}</strong> project views remaining.  <a href="javascript:void(0)" onClick={() => this.toggle()}>Learn More &raquo;</a></div>
				<span>{`Your monthly billing cycle resets on ${restDate}.`} </span> 
	          </p>  

	       
	          <Modal
		          isOpen={modal}
		          toggle={this.toggle}
		          modalClassName={`ltr-support`}
				  className={`modal-dialog--primary ${modalClass}`}
		        >
		        <div className="modal__header">
			        <button className="lnr lnr-cross modal__close-btn" type="button" onClick={this.toggle} />
			        <h4 className="text-modal  modal__title"><AlertIcon size={24} color={'#EDDEF5'} /> About Project Views</h4>
			      </div>
			      <div className="modal__body">
			      	<p style={{fontSize:16}}>{`Your current subscription allows you to view ${maxViews} projects each billing cycle.  Viewing the same project twice does not count toward your views.`}</p> 
					<p style={{fontSize:16}}>{`Your project views reset at the end of each billing cycle, on ${restDate}.`}</p>	      	      
			      </div>
			      
			      <ButtonToolbar className="modal__footer offering-status">
			        {/*<Button className="modal_cancel" onClick={this.toggle}>Cancel</Button>{' '}*/}
			        <Button className="modal_ok btn btn-primary" onClick={this.toggle} color={`primary`}>
			        	Ok
			        </Button>
			      </ButtonToolbar>
		        </Modal>     
	      </Alert>
	    );
    
  }
}


function mapStateToProps(state) {
	console.log(state);
  const buyersLists = state.buyersLists.priorityFilter
    ? state.buyersLists.buyersLists.filter(item => item.priority === state.buyersLists.priorityFilter)
    : state.buyersLists.buyersLists;
  return { buyersLists, 
	  		theme: state.theme, 
	  		rtl: state.rtl, 
	  		user: state.user, 
	  		viewedBuildings: Array.isArray(state.buyersLists.viewedBuildings) ? state.buyersLists.viewedBuildings.slice() : [],
	  		dataSet : state.buyersLists.dataSet
	  	};
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators(buyersListActions, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectViewsAlert);